/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=cfc6d900&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=cfc6d900&scoped=true&lang=css"

import exportComponent from "/Users/yaogengzhu/Documents/soft-open/software-platform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc6d900"]])

export default __exports__